
// time to visit by contractor
export const visitTime = {
    name: "visitTime",
    title: "زمان حدودی مناسب برای بازدید از محل پروژه چه زمانی است؟",
    mode: "radio",
    items: [
        {
            key: 'IMMEDIATE',
            label: 'خیلی زود'
        },
        {
            key: 'NEXT_THREE_DAYS',
            label: 'تا ۳ روز آینده'
        },
        {
            key: 'NEXT_WEEK',
            label: 'تا ۷ روز آینده'
        },
        {
            key: 'NEXT_MONTH',
            label: 'تا یک ماه آینده'
        },
        {
            key: 'NO_VISITING',
            label: 'فعلا قصد اجرا ندارم و نیازی به بازدید نیست'
        }
    ]
}

export const preferation = {
    name: "preferation",
    title: "کدوم گزینه برای شما اهمیت بیشتری داره نسبت به بقیه؟",
    mode: "radio",
    items: [
        {
            key: "UNIQUE_CABINET_STYLE",
            label: "طراحی منحصر به فرد و مطلوب بودن نمونه کار متخصص"
        },
        {
            key: "FAIR_PRICE",
            label: "کابینت با قیمت مناسب"
        },
        {
            key: "CABINET_GUARANTY",
            label: "استفاده از ضمانت های موجود سلام‌ساختمان"
        },
        {
            key: "SS_FOLLOW_UP",
            label: "پیگیری و پشتیبانی ویژه سلام‌ساختمان"
        },
    ]
}

export const typeOfService = {
    name: "typeOfService",
    title: "به کدام یک از موارد زیر نیاز دارید؟",
    mode: "radio",
    items: [
        {
            key: "CONTRACTOR_REQUEST",
            label: "نیاز به مشاوره دارم"
        },
        {
            key: "CONSULTATION_REQUEST",
            label: "نیاز دارم متخصص (کابینت ساز) به من معرفی شود."
        },
        {
            key: "BOTH",
            label: "هم به مشاوره نیاز دارم و هم درخواست معرفیِ متخصص (کابینت ساز) دارم"
        }
    ]
}


// building metrage
export const unitMetrage = {
    name: "unitMetrage",
    title: "مساحت واحد شما تقریبا چند متره",
    mode: "radio",
    items: [
        {
            key: "کمتر از ۵۰ متر مربع",
            label: "کمتر از ۵۰ متر مربع",
        },
        {
            key: "بین ۵۰ تا ۱۰۰ متر مربع",
            label: "بین ۵۰ تا ۱۰۰ متر مربع"
        },
        {
            key: "بین ۱۰۰ تا ۱۵۰ متر مربع",
            label: "بین ۱۰۰ تا ۱۵۰ متر مربع"
        },
        {
            key: "بیشتر از ۱۵۰ متر مربع",
            label: "بیشتر از ۱۵۰ متر مربع"
        }
    ]
}

export const material = [
    {
        key: "mdf",
        label: "ام‌دی‌اف",
    },
    {
        key: "hiGlass",
        label: "هایگلاس"
    },
    {
        key: "membrane",
        label: "ممبران"
    },
    {
        key: "coverWithWood",
        label: "روکش چوب"
    },
    {
        key: "completlyWood",
        label: "تمام چوب"
    },
    {
        key: "unknown",
        label: "هنوز تصمیم نگرفته‌ام و نیاز به مشاوره دارم"
    }
]

// have design
export const design  = {
    name: "hasDesign",
    title: "آیا طراحی دارید ؟",
    mode: "radio",
    items: [
        {
            key: 'YES',
            label: 'بله طراحی دارم'
        },
        {
            key: 'NO_BUT_I_HAVE_PICTURES',
            label: 'خیر طراحی ندارم ولی عکس و اندازه از فضا دارم'
        },
        {
            key: 'NO',
            label: 'خیر طراحی و عکس ندارم'
        }
    ]
}

// have design
export const projectInformation = {
	name: "type",
	title: "آیا طراحی دارید ؟",
	items: [
		{
			key: "house-metr",
			label: "حدودا متراژ خونه رو دارم.",
		},
		{
			key: "kabinet-metr",
			label: "می‌دونم حدودا چند متر کابینت نیاز دارم.",
		},
		{
			key: "photo",
			label: "عکس از آشپزخونه دارم و میتونم بفرستم.",
		},
		{
			key: "material",
			label: "جنس مورد نظرمو انتخاب کردم.(های گلس،ممبران...)",
		},
		{
			key: "nothing",
			label: "هیچ کدوم از این اطلاعات رو ندارم",
		},
	],
};// have design

